module.exports = __webpack_public_path__ + "img/sack-dollar.77c35712.svg";